import Dexie from "dexie";

export const cacheDb = new Dexie('haier_db');
cacheDb.version(2).stores({
  carts: "",
  shipping:""
})